import React, { useContext, useState } from 'react';
import filterIcon from "../../../../assests/img/filter-icon-img.svg"
import AttributeListPill from './AttributeListPill';
import ReactDOM from 'react-dom';
import { ProductsContext } from '../ProductsContext';
import { TFilters } from 'types/hooks/useTable';
import ViewMoreButton from 'Components/Common/components/ViewMoreButton';

type MyProps = {
  categoryid: string
  handleAttributesChange: (attributes: string[]) => void,
  filters: TFilters
}

const ProductFilter = ({ filters, handleAttributesChange }: MyProps) => {
  const prodContext = useContext<any>(ProductsContext);

  const { attributes, attributeError, totalAttributeCount, attributePage, setAttributePage } = prodContext

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    if (!isMenuOpen) {
      prodContext.setCategorySearch("")
    }
    setIsMenuOpen(!isMenuOpen);
  };
  const onClickedViewMoreButton = () => {
    setAttributePage(attributePage + 1)
  };
  const overlayClasses = 'tw-abosulte tw-inset-0 tw-bg-black tw-opacity-50 tw-z-40 tw-h-full tw-w-full';
  const menuClasses = isMenuOpen ? 'tw-absolute tw-top-0 tw-right-0 tw-max-h-full tw-overflow-auto tw-inset-y-0 tw-right-0 tw-w-80 tw-bg-white tw-z-50 tw-transform tw-translate-x-0 tw-transition-transform tw-ease-in-out tw-duration-300' : ' tw-transform tw-translate-x-full tw-transition-transform tw-ease-in-out tw-duration-300';

  const sidePanelPortal = document.querySelector('#sidepanel-portal')

  return (
    <div>
      <div onClick={toggleMenu} className={`hover:tw-bg-[#EBECF0] tw-p-2 tw-mx-3 tw-rounded-[4px] tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-[6px]`}>
        <img className={`tw-w-[16.56px] tw-h-[15px]`} alt="Filter" src={filterIcon} />
        <button className={`tw-text-sm tw-font-normal tw-text-[#172B4D]`}>Filter</button>
      </div>
      {(isMenuOpen && sidePanelPortal) &&
        ReactDOM.createPortal(
          <div className="tw-fixed tw-top-0 tw-left-0 tw-w-screen tw-h-screen">
            <div className={overlayClasses} onClick={toggleMenu} />
            <div className={menuClasses}>
              <div className={`tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-3 tw-sticky tw-top-0 tw-bg-white tw-border-b-[1px] tw-border-solid tw-border-[#D1D1D6] tw-z-10`}>
                <h2 className={`tw-text-black tw-font-semibold tw-text-xl`}>Filter</h2>
                <button className={`tw-text-black`} onClick={toggleMenu}>
                  X
                </button>

              </div>
              <div className={`tw-box-border tw-w-full tw-h-px`} />

              <div className={`tw-px-4 tw-py-3full`}>
                {attributeError && <span>Error loading Attributes</span>}

                {!attributeError && <AttributeListPill filters={filters} attributes={attributes} handleChange={handleAttributesChange} />}
                <ViewMoreButton condition={
                  attributes?.length < totalAttributeCount && !prodContext.loadingAttributes
                } handleClick={onClickedViewMoreButton} state={false} />
              </div>
            </div>
          </div>
          , sidePanelPortal)}
    </div>
  );
};

export default ProductFilter;
